export const EXTRA_SMALL = '4px';
export const SMALL = '8px';
export const MEDIUM = '16px';
export const LARGE = '32px';
export const EXTRA_LARGE = '64px';

export const CONTENT_WIDTH = '800px';
